<template>
        <div class="warp">
            <!-- 面包屑 -->
            <breadcrumb :back="true" :crubList="[{name:'系统配置'},{name:'成功案例配置',goback:true},{name:'编辑成功案例'}]" :title="'编辑成功案例'"/>
            <!-- 表单 -->
            <div class="box">
                <div class="forms">
                  <el-form
                    :model="ruleForm"
                    :rules="rules"
                    ref="ruleForm"
                    label-width="100px"
                    class="demo-ruleForm"
                  >
                    <el-form-item label="案例内容" prop="content">
                      <el-input v-model="ruleForm.content"></el-input>
                    </el-form-item>
                    <el-form-item>
                    <el-button  size="small"type="primary" @click="submitForm('ruleForm')" :loading="subLoading" :disabled="subLoading">确认</el-button>
                      <el-button size="small" @click="resetForm('ruleForm')">取消</el-button>
                    </el-form-item>
                  </el-form>
                    
                    
                    
                </div>
            </div>
        </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';

export default {
    components:{
        breadcrumb,
    },
    data(){
        return{
          subLoading:false,
            edit:true,
            id:void 0,
            ruleForm: {
              content: null,
            },
            rules: {
              content: [
                { required: true, message: "请输入案例内容", trigger: "blur" },
              ],
            },
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        },
    },
    methods:{
      resetForm(formName) {
      // this.ruleForm = {
      //   content: null,
      // };
      // this.$refs[formName].resetField();
      this.$router.back(-1)
    },
        //保存按钮
        submitForm(formName) {
      console.log(this.ruleForm);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.edit) {
            this.$axioscBody
              .post(`/backstage/hotCase/add?content=${this.ruleForm.content}`)
              .then((r) => {
                if (r.code == 200) {
                  this.$message({
                    type: "success",
                    message: r.msg,
                  });
                  // this.getData();
                  this.resetForm(formName);
                } else {
                  this.$alert(r.msg);
                }
              });
          } else {
            if(this.subLoading) return 
            this.subLoading = true
            this.$axioscBody
              .put("/backstage/hotCase/edit", this.ruleForm)
              .then((r) => {
                this.subLoading = false
                if (r.code == 200) {
                  this.$message({
                    type: "success",
                    message: r.msg,
                  });

                  this.resetForm(formName);
                } else {
                  this.$alert(r.msg);
                }
              }).catch(e=>{
                this.subLoading = false
              })
          }
        } else {
          return false;
        }
      });
    },
    },
    mounted(){
        // this.editor = new wangEditor(this.$refs.wangEditor);
        // this.editor.customConfig.onchange =  (html) => { //通过富文本变化赋值
        //     // html 即变化之后的内容
        //     this.sendInfo.content=html;
        //     this.$vuerify.check(['sendInfo.content']);
        // }
        // this.editor.create();
    },
	created() {
    const {id} = this.$route.params
    const {content} = this.$route.query
    this.id= id || void 0
    this.ruleForm.id= id || void 0
    this.ruleForm.content = content || void 0
	}
}
</script>

<style lang="scss" scoped>
.warp{
     height:93%;
     overflow-x: hidden;
     overflow-y: auto;
    .box{
      padding:100px 0;
        .forms{
            max-width: 610px;
            margin: auto;
            transform: translateX(-100px);
            .child{
                .name{
                  width:80px;
                  text-align: right;
                  margin-right:10px;
                }
                .content{
                    flex: 1;
					/deep/ .ql-container{
						min-height: 410px;
					}
                }
            }
        }
    }
}
</style>
